module.exports = __webpack_public_path__ + "img/filters-active.b35a5013.png";